module.exports = __webpack_public_path__ + "img/AssociationOverlay1.7ac1ae86.jpg";